import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsToptalComponent } from './simple-icons-toptal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsToptalComponent ],
    exports:      [ SimpleIconsToptalComponent ],
    bootstrap:    []
})
export class SimpleIconsToptalModule {}
